import Vue from 'vue'
import Element from 'element-ui'
// import locale from 'element-ui/lib/locale/lang/en'
// import locale from 'element-ui/lib/locale/lang/zh-CN'
// Vue.use(Element, { locale })
Vue.use(Element)
